"use client";
import { Button, Stack, Typography } from "@mui/material";
import Image from "next/image";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { TitleGradientText } from "../title_gradient_text";
import { useRouter } from "next/navigation";

export function TitleSection() {
  const router = useRouter();

  const handleBrandQuualityClick = () => {
    router.push('/brand-quality');
  };

  return (
    <Stack
      width="100%"
      height="670px"
      sx={{
        backgroundImage: {
          xs: `url(/images/home/title_bg_mobile.png)`,
          md: `url(/images/home/title_bg.png)`,
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      justifyContent="center"
      alignItems="center"
      p={4}
      gap={6}
    >
      <Image
        src="/images/logo.png"
        width={191}
        height={120}
        alt="Picture of the Logo"
      />
      <TitleGradientText mt={4} variant="h5">
        ปลาร้าเชฟไพรฑูรย์
      </TitleGradientText>
      <Typography textAlign="center">
        เรามุ่งมั่นพัฒนาสินค้าและบริการอย่างไม่หยุดยั้ง ผู้บริโภคจึงมั่นใจได้ว่า{" "}
        <br />
        ผลิตภัณฑ์ภายใต้เครื่องหมายการค้า “เชฟไพรฑูรย์” มีมาตรฐาน สะอาด
        ปลอดภัยและถูกสุขลักษณะ
      </Typography>
      <Stack mt={15}>
        <Button variant="contained" onClick={handleBrandQuualityClick}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="button" color="textPrimary">
              คุณภาพของแบรนด์
            </Typography>
            <ArrowForwardRoundedIcon
              style={{
                color: "#fff",
              }}
            />
          </Stack>
        </Button>
      </Stack>
    </Stack>
  );
}
